// extracted by mini-css-extract-plugin
export var area = "areas-module--area--2CaNv";
export var spacer = "areas-module--spacer--2FEvV";
export var areaimage = "areas-module--areaimage--87tln";